import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
// import { useHistory } from 'react-router-dom';

function useManageTopics({ classID, courseID, chapterID }) {
  // const history = useHistory();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopic(data) {
    return privateFetch.post(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic`,
      data
    );
  }

  function updateTopic({ topicID, ...data } = {}) {
    return privateFetch.put(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}`,
      data
    );
  }

  function deleteTopic(topicID) {
    return privateFetch.delete(
      `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}`
    );
  }

  function manageTopics({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateTopic(data);
    }

    if (type === 'DELETE') {
      return deleteTopic(data?.topicID);
    }

    return addTopic(data);
  }

  return useMutation(manageTopics, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
      queryClient.invalidateQueries('subject-chapter-topics');
    },
  });
}

export default useManageTopics;
